
export default {
  name: "DsfCustomQueryLogicNode",
  inject: {
    $queryLogic:{
      default:null
    },
    $queryTree: {
      default: null
    },
    $queryNode: {
      default: null
    }
  },
  provide() {
    return {
      $queryNode: this
    };
  },
  props: {
    data: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  beforeCreate() { },
  created() { 
    if(this.data&&this.$queryTree){
      this.$queryTree.setNode(this.data);
    }
  },
  beforeMount() { },
  mounted() {
    // this.initDragDrop();
  },
  beforeDestroy() { },
  destroyed() { },
  methods: {
    renderGroup(h, data) {
      // return h('dsf-custom-query-logic-group',{
      //   props:{
      //     data:data
      //   }
      // })
      // return h('dsf-custom-query-logic-group',{
      //   props:{
      //     data: data
      //   }
      // });
      return (
        <dsf-custom-query-logic-group props={{ data: data }}></dsf-custom-query-logic-group>
      );
    },
    renderItem(h, data) {
      // return h('dsf-custom-query-item',{
      //   props:{
      //     data:data
      //   }
      // })
      return (
        <dsf-custom-query-item props={{ data: data }}></dsf-custom-query-item>
      )
    }
  },
  render(h) {
    if (this.data.isGroup) {
      if (this.data.items.length > 1) {
        return this.renderGroup(h, this.data);
      }
      else if (this.data.items.length == 1) {
        let data = this.data.items[0];
        if (data?.items?.length > 1) {
          return this.renderGroup(h, data);
        }
        else if (data?.items?.length == 1) {
          return this.renderItem(h, data.items[0]);
        }
        else {
          return this.renderItem(h, data);
        }
      }
    }
    else if (this.data.isLeaf && dsf.isDef(this.data.field)) {
      return this.renderItem(h, this.data);
    }
    return h();
  }
};

